import { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

export const BREADCRUMB_STYLES: BreadcrumbDesignTokens = {
  root: {
    padding: '0.875rem',
    gap: '0.4375rem',
  },
  item: {
    color: '{primary.500}',
    hoverColor: '{primary.500}',
  },
  css: ({ dt }) => `
    .p-breadcrumb-item-label {
      font-size: 0.875rem;
    }
        
    .p-breadcrumb-separator .p-icon {
      width: 0.875rem;
      height: 0.875rem;
    }
      
    .p-breadcrumb-item-link.p-menuitem-link-active .p-breadcrumb-item-label,
    .p-breadcrumb-item-link.p-menuitem-link-active:hover .p-breadcrumb-item-label {
      color: ${dt('surface.500')};
      cursor: default;
    }`,
};
